// extracted by mini-css-extract-plugin
export default {"group_action":"goup-action_group_action__WqcCV","pin":"goup-action_pin__o9jtu"};